<template>
<div class="chapter">
<div class="inner_page">
<h2 class="toc-title">TABLE OF CONTENTS</h2>
<p class="toc-fm"><a href="#/xhtml/fm03"><em class="italic">Like Writing on Water</em></a></p>
<p class="toc-fm"><a href="#/xhtml/fm04"><em class="italic">Foreword</em></a></p>
<p class="toc-fm"><a href="#/xhtml/fm05"><em class="italic">Where Everything Begins and Ends</em></a></p>
<p class="toc-fm"><span href="#/xhtml/fm06" title="Link target outside of Sample"><em class="italic">A Young Life Glossary of Terms</em></span></p>
<p class="toc-chapt"><span href="#/xhtml/chap01" title="Link target outside of Sample"><span class="tno">Chapter 1</span> A Proper Introduction</span></p>
<p class="toc-chap"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="tno">Chapter 2</span> Every Morning</span></p>
<p class="toc-chap"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="tno">Chapter 3</span> Living the Wild Life</span></p>
<p class="toc-chap"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="tno">Chapter 4</span> A Lifelong Pioneer</span></p>
<p class="toc-chap"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="tno">Chapter 5</span> “The” City</span></p>
<p class="toc-chap"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="tno">Chapter 6</span> Transition, Tragedy, and Training</span></p>
<p class="toc-chap"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="tno">Chapter 7</span> The Training Program Document</span></p>
<p class="toc-chap"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="tno">Chapter 8</span> Working with “Big Kids”</span></p>
<p class="toc-chap"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="tno">Chapter 9</span> Back in the Saddle Again</span></p>
<p class="toc-chap"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="tno">Chapter 10</span> A Principled Man</span></p>
<p class="toc-chap"><span href="#/xhtml/chap11" title="Link target outside of Sample"><span class="tno">Chapter 11</span> Ethiopia: The Sequel</span></p>
<p class="toc-chap"><span href="#/xhtml/chap12" title="Link target outside of Sample"><span class="tno">Chapter 12</span> A New Vision</span></p>
<p class="toc-fmt"><span href="#/xhtml/bm01" title="Link target outside of Sample"><em class="italic">Afterword</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm02" title="Link target outside of Sample"><em class="italic">Appendix</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm02" title="Link target outside of Sample"><em class="italic">Chuck’s Core Principles</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm03" title="Link target outside of Sample"><em class="italic">Even More (!) Principles Learned Along the Way…</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm04" title="Link target outside of Sample"><em class="italic">Bible Studies: Jesus and His Worship Time, Mark 1:35–38</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm05" title="Link target outside of Sample"><em class="italic">Bible Studies: The Centurion’s Servant, Luke 7:1–10</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm06" title="Link target outside of Sample"><em class="italic">Recommended Books and Websites</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm07" title="Link target outside of Sample"><em class="italic">Acknowledgements</em></span></p>
<p class="toc-fm"><span href="#/xhtml/bm08" title="Link target outside of Sample"><em class="italic">About the Author</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?ec457b6a